module.exports = __webpack_public_path__ + "static/media/menu-home.169f6400.svg";